
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { CreateUserDialog } from "./CreateUserDialog";
import { Home } from "lucide-react";

interface AdminHeaderProps {
  onUserCreated: () => void;
}

export const AdminHeader = ({ onUserCreated }: AdminHeaderProps) => {
  const navigate = useNavigate();
  
  return (
    <div className="flex justify-between items-center mb-8">
      <div className="flex items-center gap-4">
        <Button 
          variant="ghost" 
          size="icon"
          onClick={() => navigate("/admin")}
          className="mr-4"
        >
          <Home className="h-5 w-5" />
        </Button>
        <h1 className="text-3xl font-bold">Admin Dashboard</h1>
      </div>
      <div className="space-x-4">
        <CreateUserDialog onUserCreated={onUserCreated} />
        <Button onClick={() => navigate("/")}>Tilbage til forsiden</Button>
      </div>
    </div>
  );
};
